/* Product-grid redesign (2026-07): one-click size add on product cards.
 *
 * When the size panel on a product card is open and the shopper picks a
 * size pill, submit the card's add-to-cart form immediately, then close
 * the panel (the theme's cart drawer opens on success as usual).
 *
 * Progressive enhancement: without this file the panel still works —
 * the shopper picks a size and presses the Add to cart button below the
 * pills. Safe ordering is guaranteed because VariantPill's own 'change'
 * handler (global.js) updates the form's [name="id"] input synchronously
 * before this document-level listener runs.
 *
 * Guards:
 *  - only pills inside the card panel (.product-card-variants), never the
 *    color switcher on the photo;
 *  - only single-option products (e.g. Size only) — multi-option products
 *    need every option chosen, so they keep the explicit Add button;
 *  - never fires for unavailable variants (disabled pill / disabled button).
 */
(function () {
  'use strict';
  if (window.__hhCardQuickAdd) return;
  window.__hhCardQuickAdd = true;

  /* lets CSS hide the redundant confirm button in single-option size panels */
  document.documentElement.classList.add('hh-quickadd');

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.closest) return;

    var panelPill = input.closest('.product-card-variants variant-pill');
    if (!panelPill) return;

    var card = input.closest('product-card');
    if (!card || !card.classList.contains('--drawer-active')) return;

    if (card.querySelectorAll('.product-card-variants variant-pill').length !== 1) return;
    if (input.classList.contains('disabled')) return;

    var atcButton = card.querySelector('atc-submit button[name="add"]');
    if (!atcButton || atcButton.disabled) return;

    atcButton.click();

    /* close the size panel; the cart drawer takes over */
    var closeToggler = card.querySelector('.variants-toggler--back');
    if (closeToggler) {
      window.setTimeout(function () {
        if (card.classList.contains('--drawer-active')) closeToggler.click();
      }, 250);
    }
  });
})();
